import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const AuthContext = createContext({ currentUser: null, loading: false });

export function AuthProvider({ token, children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!token) { setCurrentUser(null); return; }
    let alive = true;
    setLoading(true);
    (async () => {
      try {
        const res = await fetch(`${API_URL}/api/auth/me`, { headers: { Authorization: `Bearer ${token}` } });
        if (!res.ok) return;
        const u = await res.json();
        if (alive) setCurrentUser(u);
      } catch (_) { /* silent */ }
      finally { if (alive) setLoading(false); }
    })();
    return () => { alive = false; };
  }, [token]);

  const value = useMemo(() => ({ currentUser, loading }), [currentUser, loading]);
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
